import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=bbeb082a&scoped=true"
var script = {}
import style0 from "./top-nav.vue?vue&type=style&index=0&id=bbeb082a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeb082a",
  null
  
)

export default component.exports